/* ==========================================================================
   MASKD — spider web loader
   Hides on DOMContentLoaded (or immediately if already parsed) once the
   animation has had its minimum run time. The spider itself walks the web on
   an infinite alternating CSS animation (.sl-orbit/.sl-reach), so however long that takes -- fast or
   slow connection -- the loader stays fluid instead of stalling or cutting
   to a half-loaded page. CEILING is only the ultimate safety net.
   ========================================================================== */
(function () {
  var el = document.getElementById('spider-loader');
  if (!el) return;

  var root = document.documentElement;
  var opt = el.dataset;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Matches --sl-trace (1.6s) exactly: leaveAfterLap only ever waits out
  // the *rest* of a lap, so aligning MIN to a lap boundary means the common
  // case (page ready before one full trace) adds no extra wait at all.
  var MIN = reduced ? 260 : parseInt(opt.minDuration || '1600', 10);
  var FADE = reduced ? 220 : parseInt(opt.fadeDuration || '460', 10);
  var CEILING = parseInt(opt.hardCeiling || '12000', 10);            // absolute cap — never trap the visitor
  var ONCE = opt.oncePerSession === 'true';
  var KEY = 'maskd:loader-seen';

  function seen() {
    try { return ONCE && sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  }
  function mark() {
    try { if (ONCE) sessionStorage.setItem(KEY, '1'); } catch (e) {}
  }

  /* already shown this session → remove before the first paint cost */
  if (seen()) {
    el.parentNode && el.parentNode.removeChild(el);
    root.classList.remove('sl-lock');
    return;
  }

  root.classList.add('sl-lock');

  var start = performance.now();
  var gone = false;

  function destroy() {
    root.classList.remove('sl-lock');
    if (el.parentNode) el.parentNode.removeChild(el);
    document.dispatchEvent(new CustomEvent('maskd:loader-hidden'));
  }

  function leave() {
    if (gone) return;
    gone = true;
    mark();
    el.classList.add('is-leaving');
    el.setAttribute('aria-hidden', 'true');
    var done = false;
    var finish = function () { if (!done) { done = true; destroy(); } };
    el.addEventListener('transitionend', function (e) {
      if (e.target === el && e.propertyName === 'opacity') finish();
    });
    setTimeout(finish, FADE + 120); // fallback if transitionend is skipped
  }

  function replay() {
    if (!el.isConnected) return;
    el.classList.remove('is-leaving');
    el.removeAttribute('aria-hidden');
    var clone = el.cloneNode(true);
    el.parentNode.replaceChild(clone, el);
    el = clone;
  }

  function orbitLapMs(orbit) {
    var raw = getComputedStyle(orbit).animationDuration; // e.g. "1.6s"
    var value = parseFloat(raw);
    if (isNaN(value)) return 1600;
    return raw.indexOf('ms') !== -1 ? value : value * 1000;
  }

  /* The page being ready doesn't mean "cut the spider off mid-arc" -- let
     the lap it's currently running finish (the spider is then at the outer
     or inner end of the spiral, on the web) before starting the fade. Computed from elapsed time rather
     than an animationiteration event, since that event can be delayed or
     skipped when a tab is throttled in the background. Skipped entirely
     under reduced motion, where .sl-orbit isn't animating in the first
     place. */
  function leaveAfterLap() {
    if (reduced) {
      leave();
      return;
    }
    var orbit = el.querySelector('.sl-orbit');
    if (!orbit) {
      leave();
      return;
    }
    var lap = orbitLapMs(orbit);
    /* Read the lap phase off the animation itself. `start` is when this
       deferred script ran, which is later than when the CSS animation began
       (a slow connection makes the gap larger), so a clock based on it can
       land the pause mid-lap instead of at the end of one. */
    var running = orbit.getAnimations ? orbit.getAnimations()[0] : null;
    var elapsed = running && typeof running.currentTime === 'number' ? running.currentTime : performance.now() - start;
    var remaining = lap - (elapsed % lap);
    if (remaining >= lap - 40) remaining = 0; // already essentially at a wrap point
    setTimeout(leave, remaining);
  }

  function release() {
    var wait = Math.max(0, MIN - (performance.now() - start));
    setTimeout(leaveAfterLap, wait);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', release, { once: true });
  } else {
    release();
  }

  /* Weak-connection handling: the spider loops on its own (see .sl-orbit in
     spider-loader.css) for as long as the loader is on screen, so a slow
     connection is just a longer, still-fluid wait -- release() already
     keeps it up until DOMContentLoaded regardless of how long that takes.
     CEILING is only the ultimate safety net for a load that never finishes
     at all, so the visitor is never trapped indefinitely. */
  setTimeout(function () {
    if (!gone) leave();
  }, CEILING);

  /* bail out on interaction — never trap the visitor */
  ['pointerdown', 'keydown', 'wheel', 'touchstart'].forEach(function (evt) {
    window.addEventListener(evt, function () {
      if (performance.now() - start > 300) leave();
    }, { once: true, passive: true });
  });

  /* manual replay hook: document.dispatchEvent(new Event('maskd:loader-replay')) */
  document.addEventListener('maskd:loader-replay', function () {
    if (!el.isConnected) return;
    gone = false;
    replay();
    start = performance.now();
    release();
  });
})();
